var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagInBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    x: 0.174,
    y: 0.457,
    fill: "#2E9BD9",
    rx: 4.435
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33,
    d: "m25.11 18.76-6.624 6.624a1.848 1.848 0 0 1-2.615 0l-7.936-7.928V8.217h9.239l7.936 7.937a1.848 1.848 0 0 1 0 2.605v0Zm-12.556-5.923h.01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagInBox);
export default __webpack_public_path__ + "static/media/tag-in-box.4bc10856.svg";
export { ForwardRef as ReactComponent };